import { IconProps } from "react-feather";

export function Hydropower({
  size = 24,
  color = "black",
  ...props
}: IconProps): JSX.Element {
  return (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      width={size}
      {...props}
    >
      <path
        d="M18.0254 9.76855C19.1335 11.3132 19.633 13.2129 19.4287 15.1025C19.2243 16.9921 18.3297 18.7403 16.917 20.0127C15.5043 21.2849 13.6721 21.9927 11.7705 22C9.86883 22.0071 8.03069 21.3134 6.6084 20.0518C5.17432 18.7862 4.2615 17.0329 4.04785 15.1328C3.83429 13.2328 4.33483 11.3206 5.45215 9.76855L11.7383 1L18.0254 9.76855ZM7.11621 10.9531H7.10352C6.49379 11.8042 6.13072 12.8067 6.05371 13.8506C5.9768 14.895 6.18911 15.9416 6.66797 16.873C7.14683 17.8044 7.87431 18.5853 8.76855 19.1309C9.66275 19.6763 10.6897 19.9658 11.7373 19.9658C12.7851 19.9658 13.8137 19.6765 14.708 19.1309C15.6019 18.5853 16.3279 17.8041 16.8066 16.873C17.2855 15.9416 17.4978 14.895 17.4209 13.8506C17.3439 12.8066 16.9809 11.8042 16.3711 10.9531L11.7383 4.48926L7.11621 10.9531ZM11.4424 6.1748C11.8211 6.26912 12.0869 6.60966 12.0869 7V11.0996H15.7373C16.0586 11.0997 16.3528 11.2813 16.4971 11.5684C16.6412 11.8554 16.6106 12.1993 16.4189 12.457L11.9189 18.5068C11.7003 18.8008 11.3176 18.9217 10.9697 18.8066C10.6221 18.6913 10.3877 18.3663 10.3877 18V14.4502H7.7373C7.43913 14.4502 7.16253 14.2936 7.00879 14.0381C6.8552 13.7827 6.84681 13.4655 6.98633 13.2021L10.4863 6.60156C10.6693 6.25686 11.0637 6.08068 11.4424 6.1748ZM11.5225 12.7998C11.8513 12.9171 12.0867 13.2305 12.0869 13.5996V15.4336L14.0459 12.7998H11.5225ZM9.15039 12.75H10.9521C10.6232 12.6327 10.3878 12.3194 10.3877 11.9502V10.416L9.15039 12.75Z"
        fill={color}
      />
    </svg>
  );
}
